// useApi.ts — крошечный загрузчик данных для read-экранов: loading / error / data.
// fetcher вызывается на mount и при смене deps; гонка гасится флагом alive.
// 401 (сессия истекла) приходит как ApiError — показываем ошибку на экране, а
// session-слой подхватит выход при следующем /api/me (полноценный авто-логаут
// при 401 в data-запросах — отдельная фаза).

import { useEffect, useState } from 'react';
import { ApiError } from '../api/client';

export interface AsyncState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

export function useApi<T>(fetcher: () => Promise<T>, deps: unknown[]): AsyncState<T> {
  const [state, setState] = useState<AsyncState<T>>({
    data: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let alive = true;
    setState({ data: null, loading: true, error: null });
    fetcher()
      .then((data) => {
        if (alive) setState({ data, loading: false, error: null });
      })
      .catch((err: unknown) => {
        if (!alive) return;
        const message =
          err instanceof ApiError
            ? err.status === 404
              ? 'Не найдено'
              : `Не удалось загрузить данные (${err.status})`
            : 'Не удалось загрузить данные';
        setState({ data: null, loading: false, error: message });
      });
    return () => {
      alive = false;
    };
  }, deps);

  return state;
}
